import { ReferralToHospitalCreateOrUpdateDetails } from '@dreryk/egabinet-referral-frontend-api';

import { Choice } from '@dreryk/watermelon';

import { createReferralDiagnosesPayload } from '../../shared/common.utils';
import { ReferralToHospitalFormBean } from '../ReferralToHsopitalForm/ReferralToHospitalForm.types';

export const mapReferralToHospitalFormBeanToReferralCommandDetails = (
   referralToHospital: ReferralToHospitalFormBean,
   electronic?: boolean
): ReferralToHospitalCreateOrUpdateDetails => {
   const referralDetails = new ReferralToHospitalCreateOrUpdateDetails();
   referralDetails.unitNameAndAddress = Choice.withUseDefaultIfNull(referralToHospital.unitNameAndAddress);
   referralDetails.additionalInformation = Choice.withUseDefaultIfNull(referralToHospital.additionalInformation);
   referralDetails.cito = referralToHospital.cito;
   referralDetails.hospitalWardCode = Choice.of(referralToHospital.healthcareFacilityLocationSpecialty!.code);
   referralDetails.diagnoses = createReferralDiagnosesPayload(referralToHospital.diagnoses.value);
   referralDetails.electronic = electronic ?? false;
   referralDetails.icd9ProceduresCodes = referralToHospital.icd9Procedures.map(({ code }) => code);
   return referralDetails;
};
